export default __webpack_public_path__ + "static/media/Archdeacon's Boots of the Sacred Mountain.ff12f97c.jpg";